import { buildPublicAbsoluteUrl, } from "@logscord/public-site/seo";
import { PublicServerProfileSchema, } from "@logscord/public-server";
import { formatLocale, getPublicLocaleFromPath, DefaultLocale, } from "./locales.js";
import { PublicArticlePageResponseSchema } from "./articles.js";
import { isPublicTeamView, } from "./team.js";
import { createLogscordServerStructuredData, } from "./structuredData/server.js";
import { createLogscordTeamStructuredData, } from "./structuredData/team.js";
export function createLogscordPublicHeadExtensions(options) {
    const siteUrl = options.siteUrl.replace(/\/$/, "");
    return {
        article: ({ data }) => {
            const page = PublicArticlePageResponseSchema.parse(data["publicArticlePage"]);
            return {
                title: `${page.article.title} — LogsCord`,
                description: page.article.description,
            };
        },
        server: ({ canonicalPath, data }) => {
            const server = PublicServerProfileSchema.parse(data["publicServer"]);
            const locale = getPublicLocaleFromPath(canonicalPath) ?? DefaultLocale;
            const canonical = buildPublicAbsoluteUrl(siteUrl, canonicalPath);
            return {
                title: `${server.name} — LogsCord`,
                description: server.description?.trim()
                    || formatLocale(locale, "seo.server.description"),
                image: server.avatarUrl ?? options.defaultImage,
                structuredData: createLogscordServerStructuredData(canonical, server),
            };
        },
        team: ({ canonicalPath, data }) => {
            const team = data["publicTeam"];
            if (!isPublicTeamView(team))
                throw new Error("Invalid public team data for head resolution.");
            const locale = (getPublicLocaleFromPath(canonicalPath) ?? DefaultLocale);
            const description = formatLocale(locale, "seo.team.description");
            const canonical = buildPublicAbsoluteUrl(siteUrl, canonicalPath);
            return {
                structuredData: createLogscordTeamStructuredData(canonical, siteUrl, locale, description, team),
            };
        },
    };
}
//# sourceMappingURL=headExtensions.js.map